module.exports = __webpack_public_path__ + "static/media/expired.c313a50f.svg";